import { useContext } from 'react';
import { AuthContext } from '../services/authContext';
import { Navigate } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import AllChats from '../components/modules/liveChat/AllChats';

const LiveChat = () => {
    const { isLoggedIn, userProfile } = useContext(AuthContext);

    if (!isLoggedIn || !userProfile) {
        return <Navigate to="/" />;
    }
    return (
        <div id="LiveChat" className="screen">
            
            <Row>
                <Col xs={12} className="p-0">
                    <AllChats />
                </Col>
            </Row>
        </div>
    );
};

export default LiveChat;
